<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset, errors}" ref="observer" slim>
    <b-tab :title-link-class="hasErrors(errors) ? 'has-error' : ''">
      <template v-slot:title>
        {{$t('Home')}}
        <span v-if="hasErrors(errors)" style="width: 20px;height: 20px" id="home-exclamation-icon">
          <font-awesome-icon class="text-danger hover-cursor" icon="exclamation-circle"/>
        </span>
        <b-tooltip v-if="hasErrors(errors)" target="home-exclamation-icon"
                   :title="$t('You have validation errors')"/>
      </template>
      <div class="outer-container">
        <div v-if="selectedBranch">
          <div class="row">
            <div class="col-md-4">
              <input-widget :model="model" attribute="name"/>
            </div>
            <div class="col-md-4">
              <country-select-input-widget attribute="country_code" :model="model"/>
            </div>
            <div class="col-md-4">
              <input-widget attribute="email" :model="model"/>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <input-widget :model="model" attribute="address"/>
            </div>
            <div class="col-md-4">
              <input-widget :model="model" attribute="address_2"/>
            </div>
            <div class="col-md-4">
              <input-widget :model="model" attribute="address_3"/>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <input-widget :model="model" attribute="city"/>
            </div>
            <div class="col-md-4">
              <input-widget :model="model" attribute="state"/>
            </div>
            <div class="col-md-4">
              <input-widget :model="model" attribute="zip_code"/>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <input-widget :model="model" attribute="phone"/>
            </div>
            <div class="col-md-4">
              <input-widget :model="model" attribute="phone_2"/>
            </div>
            <div class="col-md-4">
              <input-widget :model="model" attribute="vat_number"/>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <input-widget :model="model" attribute="bank_address"/>
            </div>
            <div class="col-md-4">
              <input-widget :model="model" attribute="bank_address_2"/>
            </div>
            <div class="col-md-4">
              <input-widget :model="model" attribute="bank_address_3"/>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <input-widget :model="model" attribute="contact_info" type="textarea"/>
            </div>
            <div class="col-md-12">
              <input-widget :model="model" attribute="description" type="textarea"/>
            </div>
          </div>
        </div>
        <no-data-available :height="5" v-if="!selectedBranch"/>
      </div>
    </b-tab>
  </ValidationObserver>
</template>

<script>
  import InputWidget from "../../../../core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import CountrySelectInputWidget from "../../../../core/widgets/CountrySelectInputWidget";
  import NoDataAvailable from "../../../../core/components/common/NoDataAvailable";

  const {mapState} = createNamespacedHelpers('setup/branch');
  export default {
    name: "Home",
    components: {NoDataAvailable, CountrySelectInputWidget, InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      }
    },
    data() {
      return {};
    },
    computed: {
      ...mapState(['selectedBranch']),
    },
    methods: {
      hasErrors(errors) {
        for (let i in errors) {
          if (errors[i].length > 0) {
            return true;
          }
        }
        return false;
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
